export const masks = {
  phone: {
    placeholder: '999-999-9999',
    mask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  }
};
